<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-golf</v-icon>
        <h1 class="page-title">Association</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" lg="4" md="10" sm="12">
          <v-text-field
            v-model="association.name"
            label="Name"
            :rules="nameRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="2" sm="12">
          <v-text-field
            v-model="association.startYear"
            label="Year"
            type="number"
            :rules="yearRules"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" md="6" sm="12">
          <v-select
            label="Small Image"
            :items="images"
            v-model="association.smallImage"
          >
          </v-select>
        </v-col>
        <v-col cols="12" lg="3" md="6" sm="12">
          <v-select
            label="Large Image"
            :items="images"
            v-model="association.largeImage"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          Mission Statement
          <quill-editor v-model="association.mission"></quill-editor>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          :disabled="!valid"
          class="mr-4"
          @click="onSubmit"
          >Submit</v-btn
        >
      </v-row>
    </v-form>
        <div>
      <statusalert
        ref="alert"
        returnUrl=""
      ></statusalert>
    </div>

  </div>
</template>

<script>
import AssociationService from '../../services/api/AssociationService'
import statusalert from '../../components/StatusAlert'
import store from '@/store/index.js'
import authorizedMixin from '../../mixins/authorizedMixin'

// import router from '@/router/index.js'
// import statusalert from '../../components/StatusAlert'

export default {
  name: 'AssociationEdit',
  mixins: [authorizedMixin],
  components: {
    statusalert
  },
  store: store,

  data() {
    return {
      dialog: false,
      association: {
        associationId: 0,
        name: '',
        mission: '',
        smallImage: '',
        largeImage: '',
        startYear: 2015
      },
      images: ['PJ.png', 'PJGolfCourse.jpg'],
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 80 || 'Name must be 80 characters or less'
      ],
      valid: false,
      yearRules: [v => !!v || 'Year is required']
    }
  },

  created() {
    this.fetchAssociation()
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },
  methods: {
    fetchAssociation() {
      store.commit('isLoading')
      this.faqs = []
      AssociationService.get(1)
        .then(association => {
          this.association = association
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },

    onSubmit() {
      AssociationService.update(this.association)
        .then(result => {
          this.result = {
            isValid: true,
            statusCode: result.status,
            errors: ['Updated calendar event']
          }
        })
        .catch(error => {
          console.log(error)
          this.result = {
            isValid: false,
            statusCode: 404,
            errors: ['Failed to update calendar event']
          }
        })
        .finally(() => {
          store.commit('notLoading')
          this.displayAlert()
        })
    },

    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    },
  }
}
</script>

<style lang="scss" scoped></style>
